import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';

class ToTop extends React.PureComponent {
    static propTypes = {
        // content: PropTypes.object,
    };

    state = {
        toTopIsShow: false,
    };

    handleToTop = () => {
        window.scroll(0, 0);
    };

    componentDidMount() {
        window.onscroll = () => {
            const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

            const winHeight = document.body.clientHeight;

            // console.log(winHeight);

            if (scrollTop > 400 && scrollTop <= winHeight - 0) {
                this.setState({
                    toTopIsShow: true,
                });
            } else {
                this.setState({
                    toTopIsShow: false,
                });
            }
        };
    }

    render() {
        const { toTopIsShow } = this.state;

        return (
            <div className={styles.toTop}>
                <div className={styles.qrCodeBox} id="">
                    <div className={styles.qrCode}>
                        <a
                            href="http://v.ifeng.com/apps/index.shtml"
                            target="_blank"
                            sign-trs-href="http://v.ifeng.com/apps/index.shtml">
                            <img
                                src="http://p2.ifengimg.com/a/2016/0506/b9b0120ef4865e4size12_w110_h110.png"
                                alt=""
                                title=""
                            />
                        </a>
                    </div>
                    <p className={styles.codeBlack}>电视不播的</p>
                    <p className={styles.codeGray}>真相在这找</p>
                </div>
                <div className={styles.vPanelFeed} id="js_vfeed">
                    <div className={styles.vPanelFeedSimple}>
                        <a
                            className={styles.vPanelFeedView}
                            href="http://v.ifeng.com/help.shtml"
                            title=""
                            target="_blank"
                            sign-trs-href="http://v.ifeng.com/help.shtml">
                            <em>反 馈</em>
                        </a>
                    </div>
                </div>
                {/* {toTopIsShow ? ( */}
                <div
                    className={styles.vPanelTop}
                    style={{ display: toTopIsShow ? 'block' : 'none' }}
                    onClick={this.handleToTop}>
                    <div className={styles.vPanelTopSimple}>
                        <span className={styles.vPanelTopView} title="返回顶部">
                            <em>返 回</em>
                        </span>
                    </div>
                </div>
                {/* ) : null} */}
            </div>
        );
    }
}

export default errorBoundary(ToTop);
